<template>
    <v-row>
        <v-col cols="12">
            <div class="titulo">
                <h2>{{ Coordinacion }}</h2>
            </div>
        </v-col>

        <v-col cols="12">
            <ComundataTablecomp :headers="seguimientoHeaders" :items="Historial" whitSearch :search="search">
                <template v-slot:Estado="{ item }">
                    <span> {{ item.estado_reasignacion? estado_reasignacion : '-------' }}</span>
                </template>

                <template v-slot:fecha="{ item }">
                    <span>{{ item.fec_us_mod | fecha }}</span>
                </template>

                <template v-slot:tipo_res="{ item }">
                    <v-chip :color="item.tipo === 1? '#6abf69': '#0277bd'" pill dark small class="font-weight-black">
                        {{ item.tipo ===1 ? 'Encargado' : 'Suplente' }} 
                    </v-chip>

                </template>

                <template v-slot:observacion="{ item }">
                    <v-menu absolute offset-y style="max-width: 600px">
                        <template v-slot:activator="{ on }">
                            <v-row justify="space-around" v-on="on">
                                <v-icon color="indigo darken-1">fas fa-comments</v-icon>
                            </v-row>
                        </template>

                        <v-card max-width="250px" class="py-2 px-2">
                            <v-tooltip bottom color="#1b1b1b" v-if="item.aux === 1">
                                <template v-slot:activator="{ on }">
                                    <span v-if="item.observacion_asignacion === ''" style="color:red;">Sin
                                        observación</span>
                                    <span v-else>{{ item.observacion_asignacion }}</span>
                                </template>
                            </v-tooltip>

                            <v-tooltip bottom color="#1b1b1b" v-if="item.aux === 2">
                                <template v-slot:activator="{ on }">
                                    {{ item.observacion_reasignacion }}
                                </template>
                            </v-tooltip>
                        </v-card>
                    </v-menu>
                </template>
            </ComundataTablecomp>
     
        </v-col>

    </v-row>
</template>



<script>
import ComundataTablecomp from '../../../../components/ComponentsEst/ComundataTablecomp.vue';
import { seguimientoHeaders } from '../../../../helpers/headersTable';
// import TableButtonComp from '../../../../components/ComponentsEst/TableButtonComp.vue';

export default {
    components: {
        ComundataTablecomp,
        // TableButtonComp
    },
    name: 'seguimiento',
    props: ['Historial', 'Coordinacion'],

    data: () => ({
        search: '',
        seguimientoHeaders
    }),


    filters: {
        fecha: function (string) {
            var cadena1 = string.slice(0, -14)
            var cadena2 = cadena1.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1');
            return cadena2;
        }
    },
}
</script>


<style  scoped>
.titulo {
    width: 100%;
    text-align: center;
    background: #E6E6E6;
    height: 50px;
    padding-top: 12px;
    border-left: 6px solid #045FB4;
    border-right: 6px solid #045FB4;
}

.titulo h2 {
    text-transform: uppercase;
    color: #045FB4;
}
</style>